(function(angular){
    'use strict';

    var inject = ['$scope', '$timeout', 'dmsPermission', 'dmsClientService', 'dmsGridSelection', '$stateParams', 'dmsToolbarButtonDepot', 'DmsToolbarButtonFactory', 'dmsProjectList', '$state', 'bmProjectApplicationService'];
    var storageMaster = function($scope: any, $timeout: any, dmsPermission: any, dmsClientService: any, dmsGridSelection: any, $stateParams: any, dmsToolbarButtonDepot: any, DmsToolbarButtonFactory: any, dmsProjectList: any, $state: any, bmProjectApplicationService: any) {

        var operationsSinceRefresh = 0;
        $scope.clientId = $stateParams.clientId;
        $scope.iconService = {
            iconFor: function(scheduleItemView: any, out: any, countryCode: any) {
                return bmProjectApplicationService.iconFor(scheduleItemView, out, countryCode);
            }
        };

        $scope.container = {
            itemType: 'Client',
            id: $stateParams.clientId,
            permissions: {
                addContents: true
            }
        };

        var buttons = dmsToolbarButtonDepot.buttons;
        $scope.buttons = [
            buttons.newFolder,
            new DmsToolbarButtonFactory('manageDocs', /* i18nextract */'Bluemoon.DMS.Toolbar.FolderGrid.Manage').children([
                buttons.rename,
                buttons.remove,
                buttons.share
            ]).button()
        ];

        function refresh() {
            $scope.$broadcast('refresh-storage-grid');
            operationsSinceRefresh = 0;
        }

        $scope.getGridItems = function() {
            return dmsProjectList.getGridItems($scope, $scope.clientId);
        };

        $scope.$on('dms-operation-complete', function(event: any, operationModel: any) {
            var op = operationModel.type;
            if (op === 'move' || op === 'copy' || op === 'add' || op === 'delete') {
                operationsSinceRefresh++;
                if (operationsSinceRefresh >= 5) {
                    refresh();
                }
            }
        });

        $scope.$on('dms-operation-batch-complete', function(){
            if (operationsSinceRefresh > 0) {
                refresh();
            }
        });

        $scope.clientSelected = function(item: any) {
            $state.go('clientStorageList', {
                clientId: item.id
            });
        };

        $scope.$on('dmsItemRenamed', refresh);
        $scope.$on('dmsItemShared', refresh);

        dmsClientService.get($scope.clientId).then(function(result: any){
            $scope.container.containerName = result.data.name;
            $scope.$emit('pageTitleUpdate', $scope.container);
        });
    };

    storageMaster.$inject = inject;

    angular.module('onvio.documents').controller('storageMaster', storageMaster);
})((window as any).angular);
